module.exports = __webpack_public_path__ + "media/images/welcome_page_quiz_questions-d7d0104dd30ee5dcc1566499e45d9653.png";